import axios from 'axios';
import useSWR from 'swr';

import { getApiUrl, formatAndThrowApiError } from '@/helpers/api';

export const useTenantSettings = () => {
  const urlStr = `${getApiUrl()}/admin/tenant-setting`;
  const swr = useSWR(
    urlStr,
    async (url) => {
      try {
        const result = await axios.get(url);
        return result.data;
      } catch (err) {
        formatAndThrowApiError(err);
      }
    },
    {
      dedupingInterval: 60000,
      revalidateOnFocus: false,
      revalidateOnReconnect: false
    }
  );
  return swr;
};

export const usePutTenantSettings = () => {
  const putTenantSettings = async (payload) => {
    try {
      const url = `${getApiUrl()}/admin/tenant-setting`;
      const response = await axios.put(url, payload);
      return response.data;
    } catch (err) {
      formatAndThrowApiError(err);
    }
  };

  return putTenantSettings;
};
